import api from './api';

class LeaderboardAPI {
    // Initialize standings for a division (admin only)
    async initializeStandings(divisionId, seasonId) {
        try {
            // Use centralized api instance (token added automatically via interceptor)
            return await api.post(`/scores/initialize-standings/${divisionId}`, { seasonId });
        } catch (error) {
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw new Error('Failed to initialize standings');
        }
    }

    // Get leaderboard for a division
    async getLeaderboard(divisionId, seasonId) {
        try {
            const params = seasonId ? { seasonId } : {};
            // Use centralized api instance (token added automatically via interceptor)
            return await api.get(`/scores/leaderboard/${divisionId}`, { params });
        } catch (error) {
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw new Error('Failed to get leaderboard');
        }
    }

    // Get leaderboard for a canton
    async getCantonLeaderboard(canton, seasonId) {
        try {
            const params = { seasonId };
            // Use centralized api instance (token added automatically via interceptor)
            return await api.get(`/scores/leaderboard-canton/${encodeURIComponent(canton)}`, { params });
        } catch (error) {
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw new Error('Failed to get canton leaderboard');
        }
    }

    // Get team's current position in division
    async getTeamPosition(teamId, divisionId, seasonId) {
        try {
            const params = { divisionId, seasonId };
            // Use centralized api instance (token added automatically via interceptor)
            return await api.get(`/scores/team-position/${teamId}`, { params });
        } catch (error) {
            if (error.response?.data?.error) {
                throw new Error(error.response.data.error);
            }
            throw new Error('Failed to get team position');
        }
    }
}

export default new LeaderboardAPI();
